var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.content.id)?_c('lite-vimeo',{ref:"vimeoVideo",style:(_vm.media ? ("background-image:url('" + _vm.poster + "')") : ''),attrs:{"videoid":_vm.content.id}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }